// Sticky CTA script for Product Detail Page (PDP)
console.log("Sticky CTA script for PDP loaded.");

// Define the selectors/IDs globally
const STICKY_BAR_ID = 'StickyATCBar';
const ORIGINAL_ATC_CLASS = 'add-to-cart-button'; 
const SCROLL_THRESHOLD_PERCENTAGE = 0.50; // Trigger after 50% of viewport height is scrolled

// Selectors for Variant Price/ID Update (FINAL, ROBUST VERSION)
const STICKY_PRICE_ID = 'StickyPrice';
const STICKY_VARIANT_INPUT_ID = 'StickyVariantIDInput';
const MAIN_PRICE_COMPONENT_SELECTOR = 'product-price'; 
const MAIN_PRICE_CONTENT_SELECTOR = '[ref="priceContainer"]'; 
const MAIN_PRODUCT_FORM_SELECTOR = '.product-details';             


// --- FUNCTION TO HANDLE VARIANT PRICE AND ID UPDATES USING MUTATION OBSERVER ---
function setupVariantChangeListeners() {
    const stickyPriceElement = document.getElementById(STICKY_PRICE_ID);
    const stickyVariantIDInput = document.getElementById(STICKY_VARIANT_INPUT_ID);
    const mainPriceComponent = document.querySelector(MAIN_PRICE_COMPONENT_SELECTOR); 
    const mainPriceContentElement = document.querySelector(MAIN_PRICE_CONTENT_SELECTOR);
    const productFormContainer = document.querySelector(MAIN_PRODUCT_FORM_SELECTOR);

    if (!stickyPriceElement || !stickyVariantIDInput || !mainPriceContentElement || !productFormContainer || !mainPriceComponent) {
        console.error('Sticky ATC: Missing elements for variant update. Check IDs/Selectors.');
        return;
    }
    
    // Function to perform the price/ID update (runs when MutationObserver detects a change)
    const updateStickyContent = () => {
        // A. Update Variant ID: Update the ID immediately, as this element is usually stable.
        const newVariantInput = productFormContainer.querySelector('[name="id"]');
        if (newVariantInput) {
            stickyVariantIDInput.value = newVariantInput.value;
        }

        // B. Price Update: Introduce a micro-delay (5ms) to wait for the theme's JS to finish writing the final price HTML.
        setTimeout(() => {
            const liveMainPriceElement = document.querySelector(MAIN_PRICE_CONTENT_SELECTOR); 
            if (liveMainPriceElement && stickyPriceElement) {
                // Copy the updated HTML content
                stickyPriceElement.innerHTML = liveMainPriceElement.innerHTML;
                console.log('Sticky ATC: Price updated after micro-delay.');
            }
        }, 5); 
        
        console.log('Sticky ATC: Mutation Observer Fired.');
    };
    
    // 1. Create a MutationObserver instance to watch the stable parent price component
    const priceObserver = new MutationObserver(function(mutationsList, observer) {
        // Run update when content (child list or text) changes on the content element or its descendants
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList' || mutation.type === 'characterData') {
                updateStickyContent();
                break; 
            }
        }
    });

    // 2. Configuration to watch for content changes
    const config = { 
        childList: true, 
        subtree: true,   
        characterData: true 
    };

    // 3. Start observing the main price component (the stable wrapper)
    priceObserver.observe(mainPriceComponent, config);
    
    // Run an initial update immediately to ensure the price and ID are correct on load
    updateStickyContent();
}

// --- CORE FUNCTIONALITY: SCROLL LISTENER & INITIALIZATION ---
function initializeStickyATC(stickyBar) {
    const originalATC = document.getElementsByClassName(ORIGINAL_ATC_CLASS)[0];
    if (!originalATC) {
        console.warn('Sticky ATC: Original ATC button not found, but scroll trigger will still function.');
    }
    
    console.log('Sticky ATC Bar successfully initialized and ready for scroll events.');

    // Introduce a small delay before setting up the listener
    setTimeout(setupVariantChangeListeners, 50); 

    function toggleStickyATC() {
        const scrollY = window.scrollY; 
        const viewportHeight = window.innerHeight; 
        const triggerThreshold = viewportHeight * SCROLL_THRESHOLD_PERCENTAGE; 

        if (scrollY > triggerThreshold) {
            stickyBar.classList.add('show');
        } else {
            stickyBar.classList.remove('show');
        }
    }

    // Attach events
    window.addEventListener('scroll', toggleStickyATC);
    toggleStickyATC(); // Run initial check
}

// --- MUTATION OBSERVER: CODE TO WAIT FOR STICKY BAR TO APPEAR ---
let stickyBarElement = document.getElementById(STICKY_BAR_ID);

if (stickyBarElement) {
    initializeStickyATC(stickyBarElement);
} else {
    console.log('Sticky ATC: Element not found, starting MutationObserver...');
    
    const observer = new MutationObserver(function(mutations, me) {
        stickyBarElement = document.getElementById(STICKY_BAR_ID);
        
        if (stickyBarElement) {
            me.disconnect(); 
            initializeStickyATC(stickyBarElement);
        }
    });

    observer.observe(document.body, {
        childList: true, 
        subtree: true    
    });
}